import { render, staticRenderFns } from "./Datatable.vue?vue&type=template&id=19828fa6&scoped=true"
import script from "./Datatable.vue?vue&type=script&lang=ts"
export * from "./Datatable.vue?vue&type=script&lang=ts"
import style0 from "./Datatable.vue?vue&type=style&index=0&id=19828fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19828fa6",
  null
  
)

export default component.exports